import { useState } from "react";
import { ScrollArea, ScrollBar } from "~/components/ui/scroll-area";
import { Button } from "../ui";
import { Calendar } from "../ui/calendar";

export function DateRangePickerCalendar({
  date,
  setDate,
}: {
  date: Date | string | undefined;
  setDate: (date: Date) => void;
}) {
  const [local, setLocal] = useState<Date | undefined>(
    date instanceof Date ? date : undefined,
  );

  function handleTimeChange(type: "hour" | "minute", value: string) {
    const currentDate = local || new Date();
    let newDate = new Date(currentDate);

    if (type === "hour") {
      const hour = parseInt(value, 10);
      newDate.setHours(hour);
    } else if (type === "minute") {
      newDate.setMinutes(parseInt(value, 10));
    }

    setLocal(newDate);
    setDate(newDate);
  }

  return (
    <div className="sm:flex">
      <Calendar
        mode="single"
        selected={local}
        onSelect={(date) => {
          if (date) {
            // The day picker hands back midnight; keep a time already picked, so
            // choosing the time before the day doesn't silently reset it to 00:00.
            const next = new Date(date);
            if (local)
              next.setHours(local.getHours(), local.getMinutes(), 0, 0);
            setLocal(next);
            setDate(next);
          }
        }}
      />
      <div className="flex flex-col sm:flex-row sm:h-[300px] divide-y sm:divide-y-0 sm:divide-x">
        <ScrollArea className="w-64 sm:w-auto">
          <div className="flex sm:flex-col p-2">
            {Array.from({ length: 24 }, (_, i) => i)
              .reverse()
              .map((hour) => (
                <Button
                  key={hour}
                  size="icon"
                  variant={
                    local &&
                    typeof local.getHours === "function" &&
                    local.getHours() === hour
                      ? "default"
                      : "ghost"
                  }
                  className="sm:w-full shrink-0 aspect-square"
                  onClick={() => handleTimeChange("hour", hour.toString())}
                >
                  {hour}
                </Button>
              ))}
          </div>
          <ScrollBar orientation="horizontal" className="sm:hidden" />
        </ScrollArea>
        <ScrollArea className="w-64 sm:w-auto">
          <div className="flex sm:flex-col p-2">
            {Array.from({ length: 12 }, (_, i) => i * 5).map((minute) => (
              <Button
                key={minute}
                size="icon"
                variant={
                  local &&
                  typeof local.getMinutes === "function" &&
                  local.getMinutes() === minute
                    ? "default"
                    : "ghost"
                }
                className="sm:w-full shrink-0 aspect-square"
                onClick={() => handleTimeChange("minute", minute.toString())}
              >
                {minute.toString().padStart(2, "0")}
              </Button>
            ))}
          </div>
          <ScrollBar orientation="horizontal" className="sm:hidden" />
        </ScrollArea>
      </div>
    </div>
  );
}
